import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import styled from "styled-components";
import { ExerciseDraft } from "@domain/lms/course/exercise/exerciseDraft";
import { TertiaryButton } from "@ui/components/buttons/tertiaryButton";
import { gap } from "@ui/styles/utils";
import { ExerciseEditor } from "@ui/pages/lms/courseEditorPage/exerciseEditor/exerciseEditor";
import { useQuizEditorController } from "@ui/pages/lms/quiz/quizEditorPage/quizEditorController/quizEditorControllerContext";

interface QuizExerciseEditorWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
	exercise: ExerciseDraft;
	deletable: boolean;
	index: number;
}

export const QuizExerciseEditorWrapper: React.FC<QuizExerciseEditorWrapperProps> = ({
	exercise,
	deletable,
	index,
	...htmlProps
}) => {
	const controller = useQuizEditorController();

	const exerciseController = useMemo(() => {
		return controller.exerciseController(exercise);
	}, [exercise.id]);

	return (
		<Container {...htmlProps}>
			<ExerciseEditor index={index} exercise={exercise} controller={exerciseController} />
			{deletable && (
				<TertiaryButton onClick={() => exerciseController.removeExercise()}>
					{I18n.t("quiz.exercise.delete")}
				</TertiaryButton>
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(40)};
`;
